/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setMobileBtn.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ハンバーガーボタン
 */
const setMobileBtn = () => {
  var body = document.body;
  var mobileBtn = document.getElementById("mobile-btn");

  mobileBtn.addEventListener("click", function () {
    body.classList.toggle("open");
  });
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setMobileBtn };
